var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "app",
      class: `client-${_vm.clientConfig ? _vm.clientConfig.id : ""}`,
    },
    [
      _c("div", { staticClass: "t-login" }, [
        _c(
          "div",
          { staticClass: "t-login__container" },
          [
            _c("div", { staticClass: "t-login__header t-logos" }, [
              _c("div", { staticClass: "t-logos__item" }, [
                _c("img", {
                  staticStyle: { "max-height": "120px" },
                  attrs: { src: _vm.logoSrc },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "t-logos__item" },
                [
                  _vm.$vlastMode
                    ? _c("vlast-text-icon", {
                        attrs: { fill: _vm.brandVlastText },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.$vlastMode && !_vm.$whitelabel
        ? _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "footer__container" }, [
              _c("div", { staticClass: "footer__row" }, [
                _c(
                  "div",
                  { staticClass: "footer__icon" },
                  [_c("vlast-logo", { attrs: { fill: "white" } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "footer__heading" }, [
                  _vm._v("Unleash your star power."),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer__row" }, [
      _c("div", { staticClass: "footer__legal" }, [_vm._v("Copyright© 2020")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }